"use client";
import Link from "next/link";
import { ArrowRight, Cpu, Brain, Telescope, Sparkles, BarChart3, Shield, Users } from "lucide-react";
import { Section, Container } from "@/components/ui/container";
import { Reveal } from "@/components/ui/reveal";
import { departments as data } from "@/lib/data/careers";

const iconMap: Record<string, React.ComponentType<{ className?: string; style?: React.CSSProperties }>> = { Cpu, Brain, Telescope, Sparkles, BarChart3, Shield, Users };
const accentColors = ["var(--color-crimson)", "var(--color-purple)", "var(--color-cyan)", "var(--color-amber)", "var(--color-emerald)", "var(--color-denim)", "var(--color-rose)"];

export function Departments() {
  return (
    <Section id="departments" className="relative">
      <Container>
        <Reveal>
          <div className="max-w-3xl">
            <span className="eyebrow-tiny text-[var(--color-emerald)]">{data.eyebrow}</span>
            <h2 className="mt-3">{data.title}</h2>
            <p className="mt-5 text-body text-[rgb(var(--fg-muted))] leading-relaxed">{data.intro}</p>
          </div>
        </Reveal>
        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {data.departments.map((d, i) => {
            const Icon = iconMap[d.icon] ?? Cpu;
            const accent = accentColors[i % accentColors.length]!;
            return (
              <Reveal key={d.title} delay={i * 50}>
                <div className="glass rounded-2xl p-5 h-full" style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 12%, transparent)` }}>
                  <span className="grid place-items-center h-10 w-10 rounded-lg" style={{ background: `color-mix(in oklch, ${accent} 18%, transparent)`, boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 35%, transparent)` }}>
                    <Icon className="h-4 w-4" style={{ color: accent }} />
                  </span>
                  <h3 className="mt-3 text-base">{d.title}</h3>
                  <p className="mt-2 text-xs text-[rgb(var(--fg-muted))] leading-relaxed">{d.body}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
        <Reveal delay={500}>
          <div className="mt-8 flex flex-wrap items-center gap-3">
            {data.cta.map((c, i) => (
              <Link key={c.label} href={c.href} className={i === 0 ? "btn-primary-gradient h-11 px-6 inline-flex items-center gap-2 rounded-full font-semibold text-sm" : "btn-glass h-11 px-6 inline-flex items-center gap-2 rounded-full font-semibold text-sm"}>
                {c.label} <ArrowRight className="h-3.5 w-3.5" />
              </Link>
            ))}
          </div>
        </Reveal>
      </Container>
    </Section>
  );
}
